import { h, Component } from 'preact';
import dlv from 'dlv';
import linkRef from 'linkref';

import { configure } from '../../../../config';
import { getImageSrc } from '../../../../lib/image';
import { trackContentLoad } from '../../../../lib/tracking';

import { getCcpaOptOutString } from '@cube/privacy-utils';
import { injectScripts } from '@cube/script-injector';
import { trackingProvider, trackEvent, INPUT_KEYS, DIMENSION, EVENT } from '@cube/track';

@configure([
	'singleCube.disableJwAds'
])
@trackingProvider({
	[DIMENSION.componentpath]: 'JwPlayer'
})
export class JwPlayer extends Component {

	trackPlay = (title, provider, vendor, id) => {
		trackContentLoad({
			context: this.context,
			id,
			title,
			provider,
			vendor,
			type: 'video'
		});

		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.play,
			[DIMENSION.contentid]: id,
			[DIMENSION.contenttitle]: title,
			[DIMENSION.player]: 'jwplayer',
			[DIMENSION.contentprovider]: provider,
			[DIMENSION.contentvendor]: vendor
		});
	};

	getVideoSources(video) {
		let sources = [];
		if (video.streams.mp4) sources.push({ file: video.streams.mp4 });
		return sources;
	}

	isValidVideo = (video) => dlv(video, 'streams.hls') || dlv(video, 'streams.dash') || dlv(video, 'streams.mp4');

	initPlayer({ video, disableJwAds }) {
		if (video && window.jwplayer && !this.state.hasLoaded) {
			this.setState({ hasLoaded: true });

			let location = window.location.origin,
				privacy = getCcpaOptOutString();

			let playlist = [{
				sources: this.getVideoSources(video.videos[0]),
				title: video.title,
				description: video.description,
				image: getImageSrc(video.images, 'w=640,h=360'),
				provider: dlv(video, 'metadata.attribution.provider'),
				vendor: dlv(video, 'metadata.attribution.vendor'),
				id: dlv(video, 'metadata.canonical_id')
			}];

			if (video.playlist) {
				video.playlist.forEach( otherVideo => {
					if (this.isValidVideo(otherVideo.videos[0])) {
						playlist.push({
							sources: this.getVideoSources(otherVideo.videos[0]),
							title: otherVideo.title,
							description: otherVideo.description,
							image: getImageSrc(otherVideo.images, 'w=300,h=169'),
							provider: dlv(otherVideo, 'metadata.attribution.provider'),
							vendor: dlv(otherVideo, 'metadata.attribution.vendor'),
							id: dlv(otherVideo, 'metadata.canonical_id')
						});
					}
				});
			}

			let playerConfig = {
				playlist,
				width: '100%',
				height: '100%',
				primary: 'html5',
				pipIcon: 'disabled',
				autostart: true,
				repeat: true,
				floating: true,
				autoPause: {
					viewability: true,
					pauseAds: true
				}
			};

			if (!disableJwAds) {
				let tagStart = 'https://vid.springserve.com/rt/1276?cb=1234&placement=1&content_title=__item-title__&provider=__item-provider__&url=' + encodeURIComponent(location) + '&us_privacy=' + privacy;

				// Try and get height and width of parent to send to springserve
				if (this.refs) {
					let height = dlv(this.refs, 'imdsJwPlayer.parentNode.clientHeight'),
						width = dlv(this.refs, 'imdsJwPlayer.parentNode.clientWidth');

					if (height && width) {
						tagStart += `&h=${height}&w=${width}`;
					}
				}

				playerConfig.advertising = {
					client: 'vast',
					adscheduleid: '123asd23',
					requestTimeout: 12000,
					vastLoadTimeout: 12000,
					schedule: [{
						offset: 'pre',
						tag: tagStart
					},
					{
						offset: '240',
						tag: tagStart
					},
					{
						offset: '480',
						tag: tagStart
					},
					{
						offset: '720',
						tag: tagStart
					}]
				};
			}

			window.jwplayer.key = 'jvValXdgZHamHqESGjvQJZXwcLpROB8pbRygOQ==';
			let player = window.jwplayer('imdsJwPlayer').setup(playerConfig);

			player.on('firstFrame', (e) => {
				let item = window.jwplayer().getPlaylistItem(window.jwplayer().getPlaylistIndex());
				this.trackPlay(item.title,  item.provider, item.vendor, item.id);
			});

			player.on('adImpression', (e) => {
				trackEvent(this.context, {
					[INPUT_KEYS.action]: EVENT.videoadimpression,
					[DIMENSION.contenttitle]: e.adtitle,
					[DIMENSION.player]: 'jwplayer'
				});
			});
		}
	}

	componentWillMount() {
		injectScripts([
			{
				src: this.props.portalStaticOrigin + '/_shared/video-player/scripts/jwplayer/jwplayer-8.26.8/jwplayer.js'
			}
		]).then(() => {
			this.initPlayer(this.props);
		});
	}

	componentDidMount() {
		this.initPlayer(this.props);
	}

	render({ }) {
		return (
			<div ref={linkRef(this, 'imdsJwPlayer')} id="imdsJwPlayer" />
		);
	}
}
